"use client";
import { useState } from "react";
import "../../../styles/form.scss";
import styles from "@/app/styles/components/pages/corporate-gifts/newsletter-form.module.scss";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [formIsValid, setFormIsValid] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [messageSent, setMessageSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState("");
  const [formSuccessMesage, setFormSuccessMesage] = useState("");
  const client_key = process.env.NEXT_PUBLIC_NEWSLETTER_CLIENT_KEY;
  const client_secret = process.env.NEXT_PUBLIC_NEWSLETTER_CLIENT_SECRET;

  const validateEmail = (email) => {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegex.test(email)) {
      setEmailError("Neispravan unos email adrese");
      return false;
    }
    setEmailError(null);
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    validateEmail(email);

    if (formIsValid && emailError === null) {
      setIsLoading(true);

      try {
        const headers = new Headers();

        headers.append(
          "Authorization",
          `Basic ${btoa(`${client_key}:${client_secret}`)}`
        );

        const formData = new FormData();
        formData.append("email", email);

        const response = await fetch(
          `https://api.poklonizanajmilije.com/wp-json/newsletter/v2/subscribers`,
          {
            method: "POST",
            headers,
            body: formData,
          }
        );

        const data = await response.json();
        if (response.status === 201) {
          setMessageSent(true);
          setIsLoading(false);
          setEmail("");

          setFormSuccessMesage("Uspešno ste se prijavili našu mailing listu!");
          setTimeout(() => {
            setFormSuccessMesage("");
          }, 3000);
        }
        if (response.status === 201) {
          setMessageSent(true);
          setIsLoading(false);
          setEmail("");

          setFormSuccessMesage("Uspešno ste se prijavili našu mailing listu!");
          setTimeout(() => {
            setFormSuccessMesage("");
          }, 3000);
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    } else {
      setFormErrorMessage("Neispravan unos podataka");
      setTimeout(() => {
        setFormErrorMessage("");
      }, 1500);
    }
  };

  const validateForm = () => {
    setFormIsValid(email.trim() !== "");
  };
  return (
    <>
      <div className={styles.form}>
        <form onSubmit={handleSubmit}>
          <input
            className={styles.inputEmail}
            id="email-input-newsletter"
            type="email"
            value={email}
            placeholder="Prijavite se na našu mailing listu"
            autoComplete="off"
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => {
              validateEmail(email);
              validateForm();
            }}
          />
          {emailError && (
            <div className={`${styles.messagePosititon} error-message `}>
              <p>{emailError}</p>
            </div>
          )}

          <input
            type="submit"
            value="Prijavi se"
            className={`${styles.submitBtn} btnGlobal`}
          />
          {isLoading && (
            <div className={`${styles.messagePosititon} loading`}>
              <p>Sačekajte...</p>
            </div>
          )}
          {messageSent && (
            <div className={`${styles.messagePosititon} success-message`}>
              <p>{formSuccessMesage}</p>
            </div>
          )}
        </form>
      </div>
    </>
  );
};

export default NewsletterForm;
